// extracted by mini-css-extract-plugin
module.exports = {"section":"KtnQwGTKhEHlPPcUSHMeH","background":"nnOGlGrUSV5wEAYXaQVxZ","body":"_1SwzM1Mz3sUgJCfO3YVQVp"};